(ns teamoesterreich.core
  (:require
    [clojure.string :as str]
    [reagent-material-ui.components :as mui]
    [reagent.dom :as rd]
    [shadow.cljs.modern :refer (js-await)]
    [teamoesterreich.actions.auth :as a-auth]
    [teamoesterreich.actions.page-flow :as page-flow]
    [teamoesterreich.config :as config]
    [teamoesterreich.firebase.auth :as f-auth]
    [teamoesterreich.firebase.provider :as fs-provider]
    [teamoesterreich.lebensretter-mode.core :as lebensretter-mode]
    [teamoesterreich.store :as store]
    [teamoesterreich.user-mode.actions :as a]
    [teamoesterreich.util.log :as log]
    [teamoesterreich.user-mode.core :as user-mode])

  (:import (goog.i18n DateTimeSymbols_de_AT)))

;(log/out " SETUP " (clj->js setup))

; rewrite old fragment based URLs, so old links keep working
(when (and (= "/" js/location.pathname) (str/starts-with? js/location.hash "#user$"))
  (let [path (second (.split js/location.hash "$"))]
    (cond
      (= path "landing") (js/history.replaceState nil nil "/")
      (= path "onboardLebensretter") (js/history.replaceState nil nil "/lebensretter")
      :else (js/history.replaceState nil nil (str "/" path)))))

(defn main [mode]
  ;; fragment
  [:<>
   [mui/css-baseline]
   (case mode
     :user [(user-mode/main)]
     :lebensretter [(lebensretter-mode/main)])
   ])

(defn try-login [mode]
  (a/set-redirect-uri mode)
  (case mode
    :user
    (-> (.signinSilent ^js config/user-manager)
        (.catch (fn [e]
                  (js/console.error "signinSilent failed" e)))
        (.then (fn [user]
                 (if user
                   (-> (a-auth/>do-login (.-access_token user))
                       (.catch (fn [e] (js/console.error ">do-login failed" e))))

                   (when-let [user (.-currentUser (js/firebase.auth))]
                     (when-not (.-isAnonymous user)
                       (-> (f-auth/logout)
                           (.catch (fn [e] (js/console.error "logout failed" e)))))))))
        (.finally (fn []
                    (f-auth/set-auth-listener)
                    (store/update-loading :auth))))

    :lebensretter
    (-> (.getUser ^js config/user-manager)
        (.then (fn [user]
                 (if user
                   (-> (a-auth/>do-login (.-access_token user))
                       (.catch (fn [e]
                                 (js/console.error ">do-login failed" e)))
                       (.then (fn [_] (fs-provider/load-user (fs-provider/get-uid))))
                       (.catch (fn [e] (js/console.error "load-user failed" e)))
                       (.then (fn [_] (fs-provider/set-user-data-syncer (fs-provider/get-uid))))
                       (.catch (fn [e] (js/console.error "set-user-data-syncer failed" e)))
                       (.then (fn [_] (fs-provider/register-location-listener (fs-provider/get-uid))))
                       (.catch (fn [e] (js/console.error "register-location-listener failed" e)))
                       (.then (fn [_] (fs-provider/load-documents (fs-provider/get-uid))))
                       (.catch (fn [e] (js/console.error "load-documents failed" e)))
                       (.then (fn [_] (fs-provider/register-user-documents-listener (fs-provider/get-uid))))
                       (.catch (fn [e] (js/console.error "register-user-documents-listener failed" e))))

                   (-> (f-auth/logout)
                       (.catch (fn [e] (js/console.error "logout failed" e)))
                       (.then (fn [_] (.signinRedirect ^js config/user-manager #js{:redirect_uri (str/join "/" [config/PUBLIC_BASE_URL "oauth/post-login/lebensretter"])}))))
                   )
                 ))
        (.finally (fn []
                    (store/update-loading :auth))))
    ))


; FIXME: sometimes page gets stuck in endless (render?) loop somewhere

(defn ^:export start []
  ;(.setLogLevel js/firebase.firestore "debug")
  (js-await [_ (config/load-texts)]
    (js-await [mode (page-flow/load-path)]
      (js-await [_ (.setPersistence (js/firebase.auth) js/firebase.auth.Auth.Persistence.LOCAL)] ;;; https://firebase.google.com/docs/auth/web/auth-state-persistence
        (log/out "MODE=" mode)
        (try-login mode)
        (js/addEventListener "popstate" (fn [e] (page-flow/load-path)))
        (rd/render [main mode] (js/document.getElementById "app"))))))


;(start)
